export default __webpack_public_path__ + "static/media/file.8d125adb.jpg";